import React from 'react';

import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { createSelector } from 'reselect';

import { emptyObject } from 'ui-components/default-props/empty';
import { getInsuranceProviderByName } from '../../../../../enums/insurance-providers';
import { ChildrenPropType } from '../../../../../prop-types/children';
import Global from '../../../../../store/global-selectors';
import { FulfillmentDisplayContext } from '../../../fulfillment/display-context';
import { useShipmentDisplay } from '../../../fulfillment/shipment-display/use-shipment-display';

const returnFulfillmentDisplaySelector = createSelector(
  (state, { returnFulfillmentId }) =>
    Global.selectEntitiesReturnById(state, {
      fulfillmentId: returnFulfillmentId,
    }) || emptyObject,
  ({ returnConfiguration, trackingInformation }) => {
    const {
      packages,
      shipFromId,
      shipFromName,
      carrierId,
      options,
      insuranceProvider: insuranceProviderName,
      shipTo,
    } = returnConfiguration || emptyObject;

    const insuranceProvider = getInsuranceProviderByName(insuranceProviderName);

    return {
      packages,
      shipFromId,
      shipFromNameFallback: shipFromName,
      size: packages[0]?.dimensions,
      carrierId,
      confirmationEnumId: options?.confirmationEnumId,
      confirmationNameFallback: options?.confirmation,
      insuranceProviderId: insuranceProvider?.insuranceProviderId,
      trackingStatus: trackingInformation?.status,
      isReturn: true,
      shipTo,
    };
  },
);

const ReturnFulfillmentDisplayContextProvider = ({ returnFulfillmentId, children }) => {
  const fulfillmentDetails = useSelector((state) => returnFulfillmentDisplaySelector(state, { returnFulfillmentId }));

  const value = useShipmentDisplay(fulfillmentDetails);

  return <FulfillmentDisplayContext.Provider value={value}>{children}</FulfillmentDisplayContext.Provider>;
};

export default ReturnFulfillmentDisplayContextProvider;

ReturnFulfillmentDisplayContextProvider.propTypes = {
  children: ChildrenPropType.isRequired,
  returnFulfillmentId: PropTypes.string.isRequired,
};
